import { BaseResponses } from '../base-responses';
export var AssetResponses;
(function (AssetResponses) {
    class AssetsListResponse extends BaseResponses.BaseContentManagementListResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    AssetResponses.AssetsListResponse = AssetsListResponse;
    class AssetsListAllResponse extends BaseResponses.ContentManagementListAllResponse {
        constructor(data) {
            super(data);
        }
    }
    AssetResponses.AssetsListAllResponse = AssetsListAllResponse;
    class ViewAssetResponse extends BaseResponses.BaseContentManagementResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    AssetResponses.ViewAssetResponse = ViewAssetResponse;
    class UploadBinaryFileResponse extends BaseResponses.BaseContentManagementResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    AssetResponses.UploadBinaryFileResponse = UploadBinaryFileResponse;
    class AddAssetResponse extends BaseResponses.BaseContentManagementResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    AssetResponses.AddAssetResponse = AddAssetResponse;
    class UpdateAssetResponse extends BaseResponses.BaseContentManagementResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    AssetResponses.UpdateAssetResponse = UpdateAssetResponse;
    class UpsertAssertResponse extends BaseResponses.BaseContentManagementResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    AssetResponses.UpsertAssertResponse = UpsertAssertResponse;
})(AssetResponses || (AssetResponses = {}));
//# sourceMappingURL=asset-responses.js.map